import React, { ReactNode, useCallback, useEffect } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useTranslation } from "react-i18next";
import { useSelectCurrentUser } from "@/libs/auth/redux/auth.slice";
import Delay from "@/libs/shared/components/Delay/Delay";
import AppLoader from "@/libs/shared/components/AppLoader/AppLoader";

export default function AppInitializer({
  children,
}: Readonly<{ children: ReactNode }>) {
  const router = useRouter();
  const user = useSelectCurrentUser();
  const pathname = usePathname();
  const { i18n } = useTranslation();
  const searchParams = useSearchParams();
  const redirect = searchParams?.get("redirect")!;

  const language = user?.language || "it";

  const changeLanguage = useCallback(
    async (lng: string) => {
      await i18n.changeLanguage(lng);
    },
    [i18n],
  );

  useEffect(() => {
    void changeLanguage(language);
  }, []);

  useEffect(() => {
    if (user?.idToken && pathname === "/") {
      if (redirect) {
        router.push(decodeURIComponent(redirect));
      } else {
        router.replace("/dashboard");
      }
    }
  }, [router, user, redirect]);

  if (pathname === "/customer-checkout") {
    return <>{children}</>;
  }

  return <Delay time={500} beforeDelay={<AppLoader />} afterDelay={children} />;
}
